module.exports = __webpack_public_path__ + "img/8B.904b359b.jpg";